import { render, staticRenderFns } from "./SettingPermission.vue?vue&type=template&id=64e09810&scoped=true"
import script from "./SettingPermission.vue?vue&type=script&lang=js"
export * from "./SettingPermission.vue?vue&type=script&lang=js"
import style0 from "./SettingPermission.vue?vue&type=style&index=0&id=64e09810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e09810",
  null
  
)

export default component.exports